import { useCallback, useEffect, useMemo } from 'react';
import { CarCardType } from '~/data/types/car/cars';
import { setCar } from '~/redux-toolkit/slices/carSlice';
import { useAppDispatch, useAppSelector } from '~/redux-toolkit/store/hooks';
import { useIsNewCar } from './useIsNewCar';
import { useRouter } from 'next/router';
import { ROUTES } from '~/data/routes';
import RESOURCES from '~/resources';
import { RootState } from '~/redux-toolkit/store/store';
import { useIsLeaseCar } from './useIsLeaseCar';

const useLeadNewResultPageCarSelected = () => {
  const dispatch = useAppDispatch();
  const isNewCar = useIsNewCar();
  const isLeaseCar = useIsLeaseCar();
  const router = useRouter();
  const { isContactUsModalOpen } = useAppSelector(
    (state: RootState) => state.contactUsSlice,
  );

  const isResultPage = useMemo(
    () =>
      isNewCar
        ? !router.pathname.split(ROUTES.RESULT_PAGE)[1].startsWith('/')
        : isLeaseCar &&
          !router.pathname.split(ROUTES.RESULT_PAGE_LEASE)[1].startsWith('/'),
    [isLeaseCar, isNewCar, router.pathname],
  );
  const setSelectedCar = useCallback(
    (car: CarCardType) => {
      router.pathname.includes(RESOURCES.NAV_PARAM_PRIVATE_LEASING_CAR);
      dispatch(setCar(car));
    },
    [dispatch, router.pathname],
  );
  useEffect(() => {
    if (isResultPage && !isContactUsModalOpen) {
      dispatch(setCar(null));
    }
  }, [isContactUsModalOpen, isResultPage, dispatch]);

  return { setSelectedCar };
};

export default useLeadNewResultPageCarSelected;
